<template>
  <section class="timeline-panel">
    <h3>{{ title }}</h3>
    <div v-if="!items.length" class="timeline-empty">No timeline events available.</div>
    <ul v-else class="timeline-list">
      <li v-for="(item, index) in items" :key="`${item.label}-${index}`" class="timeline-item">
        <div class="timeline-dot"></div>
        <div class="timeline-content">
          <p class="timeline-label">{{ item.label }}</p>
          <p class="timeline-time">{{ item.time || 'N/A' }}</p>
          <p v-if="item.note" class="timeline-note">{{ item.note }}</p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'FleetTimeline',
  props: {
    title: {
      type: String,
      default: 'Action Timeline',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.timeline-panel {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(11, 110, 243, 0.16);
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 10px 22px rgba(17, 35, 64, 0.06);
}

.timeline-panel h3 {
  margin: 0 0 10px;
  font-size: 1rem;
  color: #16385e;
  font-weight: 800;
}

.timeline-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.timeline-item {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 9px;
  padding: 7px 0;
}

.timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  margin-top: 4px;
  background: linear-gradient(135deg, #0b6ef3 0%, #084eb0 100%);
  box-shadow: 0 0 0 3px rgba(11, 110, 243, 0.15);
}

.timeline-label {
  margin: 0;
  font-weight: 800;
  font-size: 13px;
  color: #173e68;
}

.timeline-time,
.timeline-note {
  margin: 2px 0 0;
  font-size: 12px;
  color: #5f7897;
}

.timeline-empty {
  font-size: 12px;
  color: #7087a4;
}
</style>
